<template>
  <div>
    <slot
      :track-open-live-chat="trackOpenLiveChat"
      :track-vetster-education="trackVetsterEducation"
    />
  </div>
</template>

<script>
export default {
  name: 'VetsterEducation',

  methods: {
    buildPayload(eventName, url) {
      const custom = {
        select_these_resources: { url },
      };

      return {
        parent: 'content-page',
        child: 'symptom-help',
        ...(custom[eventName] || {}),
      };
    },

    trackOpenLiveChat(event, eventName) {
      this.trackVetsterEducation(event, eventName);

      this.$emit('open-live-chat');
    },

    trackVetsterEducation(event, eventName) {
      event.preventDefault();

      const { href } = event.target;

      const payload = this.buildPayload(eventName, href);

      this.$analytics.track({
        ...payload,
        eventName,
      });

      window.location.href = href;
    },
  },
};
</script>
